let kiwiClone = null;

function addChartLink() {
  if (!document.querySelector('variant-swatch-king').querySelector('._ks_text')) {
    const kiwiBtnOriginalElement = document.querySelector('span.ks-chart-modal-link.sizing-chart-modal-link.with-icon');
    const kiwiClonedElement = kiwiBtnOriginalElement.cloneNode(true);
    kiwiClonedElement.id = 'kiwi-cloned-chart-container';
    kiwiClonedElement.style.display = "block";

    const inputElement = document.querySelector('input[name="Size"]') || document.querySelector('[option-name="Taille"]');
    if (inputElement) {
      document.querySelector('.ks-chart-container.sizing-chart-container.ks-container-with-modal').style.display = "none";
      
    const sizeOption = document.querySelector('[option-name="Size"]') || document.querySelector('[option-name="Taille"]');
    if (sizeOption) {
      sizeOption.parentElement.insertBefore(kiwiClonedElement, sizeOption);
      kiwiClonedElement.style.display = "block"; 

        kiwiClonedElement.addEventListener("click", () => {
          const allContainers = document.querySelectorAll('.ks-chart-container');
          const outsideContainers = Array.from(allContainers).filter(container =>
            !container.closest('variant-swatch-king')
          );
          const firstOutsideContainer = outsideContainers[0];
          firstOutsideContainer.querySelector('._ks_text').click();
        });
      }
    }
  }
}

function debounceImmediate(func, delay) {
  let timeout;
  let called = false;
  return function (...args) {
    if (!called) {
      func.apply(this, args);
      called = true;
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
      called = false;
    }, delay);
  };
}

const debouncedLog = debounceImmediate(() => {
  addChartLink();
}, 300);

function newAddVariantMutation() {
  const targetNode = document.querySelector('variant-swatch-king');
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach(() => {
      debouncedLog();
    });
  });
  const config = {
    attributes: true,
    childList: false,
    subtree: true,
    attributeFilter: ['class', 'style']
  };
  observer.observe(targetNode, config);
}

var intervalIdKiwi = setInterval(function () {
  const fetchSwatchKing = document.querySelector('variant-swatch-king');
  if (fetchSwatchKing) {
    const fetchKiwiSizingChart = document.querySelector('.ks-chart-container.sizing-chart-container.ks-container-with-modal');
    if (fetchKiwiSizingChart && (fetchSwatchKing.querySelector('[option-name="Size"]') || fetchSwatchKing.querySelector('[option-name="Taille"]'))) {
      newAddVariantMutation();
      addChartLink();
      clearInterval(intervalIdKiwi);
    }
  }
}, 500);

